import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import fastTrack from '../../assets/images/fasttrack.png'
import downArrow from '../../assets/images/down-arrow.png'
import upArrow from '../../assets/images/up-arrow.png'
import warning_filled from '../../assets/images/warning_filled.svg'
import flightIcon from '../../assets/images/plane-filled.png'
import siteLogo from '../../assets/images/EtihadFlightLogo.png'
import minusIcon from '../../assets/images/minus.svg'
import plusIcon from '../../assets/images/plus.svg'
import truckIcon from '../../assets/images/cargo_truck.svg'
import {
	getDecimalFormattedNumber,
	getRoundedValue, getWeightUnit,
	SERVICES, WEIGHT_UNIT
} from '../../constants'
import { RATE_TYPES } from '../../constants/rateTypes'
import {
	clearItemFromSessionStorage,
	getBase64Decoded,
	getBase64Encoded,
	getFromSessionStorage,
	setToSessionStorage
} from '../../utils/StorageUtils'
import { useTranslation } from 'react-i18next'
import FlightDetailsPopup from './FlightDetailsPopup'
import getCurrentUser from '../../utils/getCurrentUser'
import leftLine from '../../assets/images/Left line_long.png'
import rightLine from '../../assets/images/Right line_long.png'
import leftLineShort from '../../assets/images/Left line_short.png'
import rightLineShort from '../../assets/images/Right line_short.png'
import {
	default as SessionKeys,
} from "../../constants/sessionKeys";
import RollingRate from './RollingRate'
import PriceAmount from './PriceUpdate'
import PriceUpdate from './PriceUpdate'

const FlightDetails = ({
	setEnquiredPresent,
	destinationAirport,
	searchFormData,
	filters,
	setSearchFormDataToState,
	setFiltersToState,
	showInfoPopup,
	closeInfoPopup,
	showChooseButton,
	showDropoffPickup,
	showRightSection,
	showFooter,
	toBeProcessedData,
	overrideCurrency,
	overrideGrandTotal,
	overrideTotalRate,
	previousRatingDetails,
	isDirectFromBooking,
	triggerAnimation = false
}) => {
	const [isExpanded, setExpanded] = useState(false)
	const encodedflightParameterObj = getFromSessionStorage('flightParameterObj');
	const flightParameterObj = encodedflightParameterObj ? getBase64Decoded(encodedflightParameterObj) : {}
	const [isFlightDetailsPopupOpen, setIsFlightDetailsPopupOpen] = useState(false);
	const isInterlineAgent = getCurrentUser()?.interlineAgent === 'Y';

	const { t, i18n } = useTranslation(['labels', 'errors'])

	useEffect(() => {
		setExpanded(false)
	}, [destinationAirport])

	const departureTime = moment(destinationAirport.departureDateTime)
	const departureDate = moment(destinationAirport.departureDateTime, 'DD-MMM-YYYY')
	const flightDate = searchFormData?.shippingDate
	const arrivalTime = moment(destinationAirport.arrivalDateTime)
	const arrivalDate = moment(destinationAirport.arrivalDateTime, 'DD-MMM-YYYY')
	const origin = destinationAirport.origin
	const destination = destinationAirport.destination
	let routes = destinationAirport.flightSegmentList
		? destinationAirport.flightSegmentList.length - 1
		: 0
	const isHideRate = (destinationAirport.isForceQueued ||
		destinationAirport.overHangShipment ||
		destinationAirport.bigShipment)
		? true
		: false

	const isNoInstantBooking =
		destinationAirport.warningMessages &&
		destinationAirport.warningMessages.length

	const history = useHistory()
	const setFlight = (flightSelected) => {
		let encoded = getBase64Encoded(flightSelected)
		setToSessionStorage('flightSelected', encoded)
		window.scrollTo(0, 100);
		history.push('/booking/summary')
	}

	const getFormatedTime = (value) => {
		let formattedTime = ''
		if (value) {
			let tempArray = value.split(':')
			formattedTime =
				parseInt(tempArray[0], 10) +
				'Hrs ' +
				(tempArray[1] && tempArray[1] != '00' ? tempArray[1] + ' Min' : '')
		}
		return formattedTime
	}


	let flightNumberValCombination = destinationAirport?.flightSegmentList?.map(segment => {
		return segment?.flightNumber
	})

	let flightDateValCombination = destinationAirport?.flightSegmentList?.map(segment => {
		return segment?.flightDate
	})




	useEffect(() => {
		if (JSON.stringify(flightParameterObj?.flightNumberVal) === JSON.stringify(flightNumberValCombination) &&
			JSON.stringify(flightParameterObj?.flightDateVal) === JSON.stringify(flightDateValCombination)) {
			setExpanded(true);
			setEnquiredPresent(true);
			setTimeout(() => {
				clearItemFromSessionStorage('flightParameterObj')
			}, 3000)
		} else {
			// setEnquiredPresent(false);
			setTimeout(() => {
				clearItemFromSessionStorage('flightParameterObj')
			}, 3000)
			return
		}
	}, [flightParameterObj, flightNumberValCombination, flightDateValCombination])

	const buildSelectedFlight = (srcFlight) => {
		const clone = JSON.parse(JSON.stringify(srcFlight || {}));

		// Apply FastTrack override if present (any of the three props)
		const hasOverride =
			(overrideCurrency !== undefined && overrideCurrency !== null) ||
			(overrideGrandTotal !== undefined && overrideGrandTotal !== null) ||
			(overrideTotalRate !== undefined && overrideTotalRate !== null);

		if (hasOverride && clone.ratingDetails && clone.ratingDetails[0]) {
			const rd = clone.ratingDetails[0];
			if (overrideCurrency) {
				rd.currency = overrideCurrency;
				rd.currencyCode = overrideCurrency;
			}
			if (overrideGrandTotal !== undefined && overrideGrandTotal !== null) {
				rd.grandTotal = overrideGrandTotal;
			}
			if (overrideTotalRate !== undefined && overrideTotalRate !== null) {
				rd.totalRate = overrideTotalRate;
			}
			// Mark for downstream logic if needed
			rd.fastTrackApplied = true;
			clone.fastTrackOverride = {
				currency: overrideCurrency || rd.currency,
				grandTotal: rd.grandTotal,
				totalRate: rd.totalRate
			};
			clone.service = SERVICES.FAST_TRACK;
		}
		return clone;
	};


	const handleFlightSelect = (flight) => {
		const flightWithOverride = buildSelectedFlight(flight);

		let tempSearchObj;
		if (
			searchFormData.isUSBound &&
			flightWithOverride.usoutbound &&
			!searchFormData.isUnknownShipment
		) {
			tempSearchObj = getBase64Decoded(getFromSessionStorage('searchObject'));
			setSearchFormDataToState(tempSearchObj);
			setFlight(flightWithOverride);
		} else if (
			flightWithOverride.usoutbound &&
			!(searchFormData.isUnknownShipment || filters?.isUnknownShipment)
		) {
			const header = t('COMMON.CONFIRM');
			const message = t('BOOKING.CONFIRM_SHIPPER_KNOWN');
			const primaryBtnLbl = t('COMMON.YES');
			const acceptFn = () => {
				tempSearchObj = getBase64Decoded(getFromSessionStorage('searchObject'));
				setSearchFormDataToState(tempSearchObj);
				setFlight(flightWithOverride);
			};
			const secondaryBtnLbl = t('COMMON.NO');
			const rejectFn = () => {
				setFiltersToState({
					...filters,
					isUnknownShipment: true
				});
			};
			showInfoPopup(
				header,
				message,
				primaryBtnLbl,
				acceptFn,
				secondaryBtnLbl,
				rejectFn
			);
		} else {
			tempSearchObj = getBase64Decoded(getFromSessionStorage('searchObject'));
			setSearchFormDataToState(tempSearchObj);
			setFlight(flightWithOverride);
		}
	};


	// const handleFlightSelect = (destinationAirport) => {
	// 	let tempSearchObj
	// 	if (
	// 		searchFormData.isUSBound &&
	// 		destinationAirport.usoutbound &&
	// 		!searchFormData.isUnknownShipment
	// 	) {
	// 		tempSearchObj = getBase64Decoded(getFromSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING))
	// 		setToSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING, getBase64Encoded(tempSearchObj));
	// 		setSearchFormDataToState(tempSearchObj)
	// 		setFlight(destinationAirport)
	// 	} else if (destinationAirport.usoutbound && !
	// 		(searchFormData.isUnknownShipment ||
	// 			filters?.isUnknownShipment)) {
	// 		const header = t('COMMON.CONFIRM')
	// 		const message = t('BOOKING.CONFIRM_SHIPPER_KNOWN')
	// 		const primaryBtnLbl = t('COMMON.YES')
	// 		const acceptFn = () => {
	// 			tempSearchObj = getBase64Decoded(getFromSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING))
	// 			setToSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING, getBase64Encoded(tempSearchObj));
	// 			setSearchFormDataToState(tempSearchObj)
	// 			setFlight(destinationAirport)
	// 		}
	// 		const secondaryBtnLbl = t('COMMON.NO')
	// 		const rejectFn = () => {
	// 			setFiltersToState({
	// 				...filters,
	// 				isUnknownShipment: true,
	// 			})
	// 		}
	// 		showInfoPopup(
	// 			header,
	// 			message,
	// 			primaryBtnLbl,
	// 			acceptFn,
	// 			secondaryBtnLbl,
	// 			rejectFn)
	// 		//alert('The route contains US outbound assenger flights. Please confirm that the shipper is known.)
	// 		//Yes
	// 		//If yes, proceed to select flight

	// 		//No
	// 		//If no, close the dialog box and set the isUnknownShipment flag to true in searchformdata
	// 	} else {
	// 		tempSearchObj = getBase64Decoded(getFromSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING))
	// 		setToSessionStorage(SessionKeys.SEARCH_FORM_DATA_BOOKING, getBase64Encoded(tempSearchObj));
	// 		setSearchFormDataToState(tempSearchObj)
	// 		setFlight(destinationAirport)
	// 	}
	// }

	const handleSeeDetailsButtonClick = () => {
		setIsFlightDetailsPopupOpen(!isFlightDetailsPopupOpen);
	};

	const primaryRating = destinationAirport?.ratingDetails?.[0];
	const previousRating = previousRatingDetails?.[0];

	// Derive display fields (override takes precedence even if original was 0)
	const displayCurrency =
		(overrideCurrency !== undefined && overrideCurrency !== null && overrideCurrency !== '')
			? overrideCurrency
			: (primaryRating?.currency || primaryRating?.currencyCode || '');

	const rawGrandTotal = (overrideGrandTotal != null ? overrideGrandTotal : primaryRating?.grandTotal);
	const rawTotalRate = (overrideTotalRate != null ? overrideTotalRate : primaryRating?.totalRate);

	const displayGrandTotal = Number(rawGrandTotal) || 0;
	const displayTotalRate = Number(rawTotalRate) || 0;
	const oldDisplayGrandTotal = Number(previousRating?.grandTotal) || 0;
	const oldDisplayTotalRate = Number(previousRating?.totalRate) || 0;
	const isAllIn = primaryRating?.allInRate;

	const getRatingDetailsToDisplay = () => {
		if (isDirectFromBooking && previousRatingDetails && oldDisplayTotalRate > displayTotalRate) {
			return <RollingRate newValue={getDecimalFormattedNumber(displayTotalRate)} oldValue={getDecimalFormattedNumber(oldDisplayTotalRate)} prefix={displayCurrency} suffix={"/" + getWeightUnit(WEIGHT_UNIT.KILOGRAM) + (isAllIn ? " (All-in)" : " ++")} triggerAnimation={triggerAnimation} />
		}

		return <>
			{displayCurrency}{" "}
			{getDecimalFormattedNumber(displayTotalRate)}
			{"/"}
			{getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
			{isAllIn ? " (All-in)" : " ++"}</>
	}

	const getAmountDetailsToDisplay = (isMobView) => {
		if(isDirectFromBooking && previousRatingDetails && oldDisplayGrandTotal){
			const oldAmount = `${displayCurrency} ${getDecimalFormattedNumber(oldDisplayGrandTotal)}`;
			const newAmount = `${displayCurrency} ${getDecimalFormattedNumber(displayGrandTotal)}`;
			if (getDecimalFormattedNumber(oldDisplayGrandTotal) !== getDecimalFormattedNumber(displayGrandTotal)) {
				return <PriceUpdate newAmount={newAmount} oldAmount={oldAmount} isMobileView={isMobView} triggerAnimation={triggerAnimation} />
			}
		}
		return <>
				{displayCurrency}{" "}
				{getDecimalFormattedNumber(displayGrandTotal)}
				</>
	}

	return (
		<>
			{/* <div className='flight-details__wrap'>
				<div
					className={`flight-details__item ${isExpanded ? 'borderB0 border-expand' : ''
						}`}
					 onClick={() => setExpanded(!isExpanded)}
				> */}
			{/* {destinationAirport.allotmentAvailable ?
						// <div className='flight-details__allotment-wrapper'>
						<div className='flight-details__allotment-indicator__flight-item' />
						// </div> 
						:
						<></>
					} */}
			{/* <div className='flight-details__left'> */}
			{/* <div
						className={
							showRightSection
								? 'flight-details__left'
								: 'flight-details__left w-100'
						}
					> */}
			{/* <div className='logo'>
							<img src={siteLogo} alt='Etihad' title='Etihad' />
							<div className='flight-details__flightNo'>
								{destinationAirport.flightSegmentList.length ? (
									destinationAirport.flightSegmentList.map((segment, index) => (
										<div key={index}>
											{segment.flightCarrierCode}
											{segment.flightNumber}
										</div>
									))
								) : (
									<></>
								)}
								{destinationAirport.flightSegmentList.length > 3 && (
									<div className='flight-details__flightNo-indicator'>
										+{destinationAirport.flightSegmentList.length - 3}
									</div>
								)}
							</div>
						</div>

						<div className='flight-details__route'>
							<div className='flight-details__route_allocationIndicator d-flex justify-content-between align-items-center'>
								<div className='badges-container d-flex align-items-center'>
									{destinationAirport.allotmentAvailable && (
										<div className='flight-details__allotment-badge'>Allotment</div>
									)} */}
			{/* <div className='flight-details__allotment-badge'>Allotment</div> */}
			{/* {(destinationAirport.overBookingAllowed ||
										destinationAirport.overHangShipment ||
										destinationAirport.bigShipment ||
										destinationAirport.isForceQueued) && (
											<div className='flight-details__no-instant-badge'>
												<div className='no-instant-booking mb-0'>
													<span>{t('CHOOSE_FLT.NO_INS_CONFIR')}</span>
												</div>
											</div>
										)}
								</div>
								<button className='details-linkbutton' onClick={handleSeeDetailsButtonClick}>see details</button>
							</div>

							<ul className='flight-details__timing'>
								<li className='flight-details__departure'>
									<div className='flight-details__departure__time'>
									<strong className='time-label d-lg-inline-block'>{departureTime.format('HH:mm')}</strong>
									<div className='origin-text'>{origin}</div>
									</div>
									<span className='departure_date'>{departureDate.format('ddd DD MMM')}</span>
									
								</li>

								<div className='flight-details__connection'>
									<div className='origin-destination-icon dark'></div> */}
			{/* {
										destinationAirport.flightSegmentList.filter((val, ind) => ind < destinationAirport.flightSegmentList.length-1).map((ind) => {
											return <>
												<div className='transit-line'></div>									
												<div className='origin-destination-icon'></div>											
											</>
										})
									} */}
			{/* <div className='transit-line'></div>
									<div className='iconsSection'>
										<i>
											{destinationAirport.flightSegmentList[0].flightType !=
												'T' ? (
												<img src={flightIcon} alt='Flight' title='Flight' />
											) : (
												<img src={truckIcon} alt='Flight' title='Flight' />
											)}
										</i>
									</div>
									<div className='transit-line' />
									<div className='origin-destination-icon dark'></div>
								</div>

								<li className='flight-details__arrival'>
								  <div className='flight-details__departure__time'>
								   <div className='origin-text'>{destination}</div>
									<strong className='time-label d-lg-inline-block'>{arrivalTime.format('HH:mm')}</strong>
									</div>
									<span className='arrival_date'>{arrivalDate.format('ddd DD MMM')}</span>
									
								</li>
							</ul>
							<span className='flight-details__elapse'>
							{routes ? (
								<span className='flight-details__routes'> */}
			{/* <span className='flight-details__routes-dep d-inline-block d-lg-none'>{departureTime.format('HH:mm')}</span> */}
			{/* <span>{routes} {t('COMMON.STOP')}</span> */}
			{/* <span className='flight-details__routes-arr d-inline-block d-lg-none'>{arrivalTime.format('HH:mm')}</span> */}
			{/* </span>
							) : (
			
								<span className='flight-details__routes'> */}
			{/* <span className='flight-details__routes-dep d-inline-block d-lg-none'>{departureTime.format('HH:mm')}</span> */}
			{/* <span></span> */}
			{/* <span className='flight-details__routes-arr d-inline-block d-lg-none'>{arrivalTime.format('HH:mm')}</span> */}
			{/* </span>
							)}
								<span className='flyinghours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</span>
							</span>
						</div> */}

			{/* Vertical Separator */}
			{/* {showRightSection && <div className='vertical-separator'></div>}
						
						{destinationAirport.service === SERVICES.FAST_TRACK && (
							<div className='flight-details__right__service'>
								<img src={fastTrack} alt='fastTrack' title='fastTrack' />
							</div>
						)}
					</div>
					
					{showRightSection && (
					<div className='flight-details__right'>
						
						<div className='flight-details__right__sub'>
							{ isInterlineAgent ? <div className='flight-details__right__sub__pricing' /> :destinationAirport.ratingDetails &&
								destinationAirport.ratingDetails.length > 0 &&
								destinationAirport.ratingDetails[0].totalRate &&
								destinationAirport.ratingDetails[0].totalRate !== 0 &&
								!isHideRate
								? (
									<div className='flight-details__right__sub__pricing'>
										<div className='flight-details__right__sub__amount'>
											<label>
												{destinationAirport.ratingDetails[0].currency}{' '}
												{getDecimalFormattedNumber(
													destinationAirport.ratingDetails[0].grandTotal
												)}
											</label>
										</div>
										<div className='flight-details__right__sub__rate'>
											<label>
												{destinationAirport.ratingDetails[0].currency}{' '}
												{getDecimalFormattedNumber(
													destinationAirport.ratingDetails[0].totalRate
												)}
												{'/'}
												{getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
												{destinationAirport.ratingDetails[0].allInRate ? ' (All-in)' : ' ++'}
											</label>
										</div>
										{
											(destinationAirport.priceClass) ? (
												<div className='rate-type mb-0 d-none d-lg-block'>
													<span>{t(RATE_TYPES[destinationAirport.priceClass])}</span>
												</div>
											) : (<></>)
										} */}
			{/* {(destinationAirport.overBookingAllowed ||
											destinationAirport.overHangShipment ||
											destinationAirport.bigShipment ||
											destinationAirport.isForceQueued) ? (
											<>
												<div className='d-none d-lg-block'>
													<div className='no-instant-booking mb-0'>
														<span>{t('CHOOSE_FLT.NO_INS_CONFIR')}</span>
													</div>
												</div>
												<div className='d-block d-lg-none'>
													{!isExpanded ? (
														<div className='no-instant-booking mb-0'>
															<span>{t('CHOOSE_FLT.NO_INS_CONFIR')}</span>
														</div>) : (<></>)
													}
												</div>
											</>
										) : (<></>)
										} */}
			{/* </div>
								) : (
									<div className='flight-details__right__sub__pricing'>
										<div className='no-rates pr-3'>
											<span>{t('COMMON.NO_RATES')}</span>
										</div> */}
			{/* <div className='d-none d-lg-block'>
											<div className='no-instant-booking mb-0'>
												<span>{t('CHOOSE_FLT.NO_INS_CONFIR')}</span>
											</div>
										</div> */}
			{/* <div className='d-block d-lg-none'>
											{!isExpanded ? (
												<div className='no-instant-booking mb-0'>
													<span>{t('CHOOSE_FLT.NO_INS_CONFIR')}</span>
												</div>) : (<></>)}
										</div> */}
			{/* </div>
								)}
							{showChooseButton && (
								<> */}
			{/* Desktop button */}
			{/* <button
										type='button'
										className='choose-button d-none d-lg-block'
										onClick={() => handleFlightSelect(destinationAirport)}
									>
										{t('COMMON.CHOOSE')}
									</button> */}
			{/* Mobile button */}
			{/* {!isExpanded && (
										<button
											type='button'
											className='primary-button d-block d-lg-none flight-details_choose'
											onClick={() => handleFlightSelect(destinationAirport)}
										>
											{t('COMMON.CHOOSE')}
										</button>
									)}
								</>
							)} */}
			{/* <div class='flight-details__arrowUp d-none d-lg-block'>
								<i>
									{isExpanded ? (
										<img src={minusIcon} alt='Flight' title='Flight' />
									) : (
										<img src={plusIcon} alt='Flight' title='Flight' />
									)}
								</i>
							</div> */}
			{/* <div class='flight-details__arrowUp d-block d-lg-none'>
								<i>
									{isExpanded ? (
										<img src={upArrow} alt='Flight' title='Flight' />
									) : (
										<img src={downArrow} alt='Flight' title='Flight' />
									)}
								</i>
							</div> */}
			{/* </div> */}
			{/* {isExpanded && showChooseButton ? (<></>) : (<button
							type='button'
							className='primary-button d-block d-lg-none flight-details_choose'
							onClick={() => handleFlightSelect(destinationAirport)}
						>
							{t('COMMON.CHOOSE')}
						</button>)} */}

			{/* </div>
					)}
				</div>
				{isFlightDetailsPopupOpen && (
					<FlightDetailsPopup
						destinationAirport={destinationAirport}
						searchFormData={searchFormData}
						onClose={handleSeeDetailsButtonClick}
						showDropoffPickup={showDropoffPickup}
						showFooter={showFooter}
					/>
				)}
			</div> */}


			<div className=' flight-details__flightlist  d-none d-lg-flex'>
				<div className='flight-card-tail-block'>
					<img src={siteLogo} alt='Etihad' title='Etihad' className='flight-card-logo' />
					<div className='flights-list'>

						{destinationAirport.flightSegmentList.length ? (
							destinationAirport.flightSegmentList.map((segment, index) => (
								<div className='flight-list-item' key={index}>
									{segment.flightCarrierCode}
									{segment.flightNumber}
								</div>
							))
						) : (
							<></>
						)}
						{destinationAirport.flightSegmentList.length > 3 && (
							<div className='flight-list-item' >
								+{destinationAirport.flightSegmentList.length - 3}
							</div>

						)}
					</div>
				</div>
				<div className='flight-card-all-content'>
					<div className='flight-card-flight-details'>
						<div className='flight-card-flight-details-top-block'>
							<div className='flight-card-flight-details-top-block-badges'>
								{destinationAirport.allotmentAvailable && (
									<div className='allotment-badges'>{t("DASHBOARD.ALLMNT")}</div>
								)}

								{(destinationAirport.overBookingAllowed ||
									destinationAirport.overHangShipment ||
									destinationAirport.bigShipment ||
									destinationAirport.isForceQueued) && (


										<div className='no-confirm-badge'>{t('CHOOSE_FLT.NO_INS_CONFIR')}</div>


									)}
							</div>
							{!toBeProcessedData && <button className='see-details-linkbutton' onClick={handleSeeDetailsButtonClick}>{t('COMMON.SEE_DETAILS')}</button>}
						</div>
						<div className={`flight-card-flight-details-bottom-block ${toBeProcessedData ? 'align-items-center' : ''}`}>
							<div className='flight-card-flight-details-bottom-block-left'>
								{
									toBeProcessedData ?
										<div className='bottom-block-left-time-airport'>
											<div className='bottom-block-left-time'>{origin}</div>
										</div> :
										<>
											<div className='bottom-block-left-time-airport'>
												<div className='bottom-block-left-time'>{departureTime.format("HH:mm")}</div>
												<div className='bottom-block-left-airport'>{origin}</div>
											</div>
											<div className='bottom-block-left-day'>{departureDate.format("ddd DD MMM")}</div>
										</>
								}
							</div>
							<div className={`flight-card-flight-details-bottom-block-middle ${toBeProcessedData ? 'justify-content-center' : ''}`}>

								<div className='plane-path'>
									{/* <div className='d-flex'></div> */}
									<div className='origin-destination-icon dark'></div>
									<div className='transit-line'></div>
									{/* <img src={leftLine} alt='leftLine' className='left-line-long' /> */}
									{destinationAirport.flightSegmentList[0].flightType !=
										'T' ? (
										<img src={flightIcon} alt='Flight' title='Flight' className='plane-path-flight-icon' />
									) : (
										<img src={truckIcon} alt='Flight' title='Flight' className='plane-path-flight-icon' />
									)}



									{/* <img src={rightLine} alt='rightLine' className='left-line-long' /> */}
									<div className='transit-line'></div>
									<div className='origin-destination-icon dark'></div>
								</div>
								{routes ? (
									<div className='duration'>
										<div className='duration-stop'>{routes} {t("COMMON.STOP")}</div>
										<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
									</div>

								) : (
									<div className='duration'>
										<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
									</div>
								)}
							</div>
							<div className='flight-card-flight-details-bottom-block-right'>
								{
									toBeProcessedData ? <div className='bottom-block-right-time-airport'>
										<div className='bottom-block-right-airport'>{destination}</div>
									</div> :
										<>
											<div className='bottom-block-right-time-airport'>
												<div className='bottom-block-right-time'>{destination}</div>
												<div className='bottom-block-right-airport'>{arrivalTime.format("HH:mm")}</div>
											</div>
											<div className='bottom-block-right-day'>{arrivalDate.format("ddd DD MMM")}</div>
										</>
								}
							</div>
						</div>
					</div>
					{/* {showRightSection  &&  <div className='vertical-divider-line'></div>} */}
					{showRightSection && (!isInterlineAgent || showChooseButton) && (
						<div className='vertical-divider-line'></div>
					)}


					{destinationAirport.service &&
						destinationAirport.service === SERVICES.FAST_TRACK && (

							<img src={fastTrack} alt="fastTrack" title="fastTrack" className='flight-card-fasttrack' />

						)}



					{showRightSection && (
						<div className='pricing-details'>
							{isInterlineAgent ? (

								<div className='pricing-details-content' />
							) : destinationAirport.ratingDetails &&
								destinationAirport.ratingDetails.length > 0 &&
								destinationAirport.ratingDetails[0].totalRate &&
								destinationAirport.ratingDetails[0].totalRate !== 0 &&
								!isHideRate ? (
								// Case 2: Valid rates
								<div className='pricing-details-content'>
									<div className='currency-info'>
										{getAmountDetailsToDisplay(false)}
									</div>
									<div className='rating-info'>
										{getRatingDetailsToDisplay()}
									</div>
									{destinationAirport.priceClass ? (
										<div className="rate-type-info">
											{t(RATE_TYPES[destinationAirport.priceClass])}
										</div>
									) : <></>}
								</div>
							) : (
								// Case 3: No rates
								<div className='no-rates'>{t("COMMON.NO_RATES")}</div>
							)}

							{showChooseButton && (
								<div className='w-100'>
									<button
										type='button'
										className='primary-button w-100'
										onClick={() => handleFlightSelect(destinationAirport)}
									>
										{t('COMMON.CHOOSE')}
									</button>
								</div>
							)}
						</div>
					)}

				</div>
				{isFlightDetailsPopupOpen && (
					<FlightDetailsPopup
						destinationAirport={destinationAirport}
						searchFormData={searchFormData}
						onClose={handleSeeDetailsButtonClick}
						showDropoffPickup={showDropoffPickup}
						showFooter={showFooter}
					/>
				)}
			</div>

			<div className='d-flex d-lg-none flight-details__flightlistmobile'>
				<div className='flight-tail-block-mobile'>
					<img src={siteLogo} alt='Etihad' title='Etihad' className='flight-card-logo-mobile' />
					<div className='flight-list-mobile'>
						{destinationAirport.flightSegmentList.length ? (
							destinationAirport.flightSegmentList.map((segment, index) => (
								<React.Fragment key={index}>
									<div className='flight-list-item-mobile' key={index}>
										{segment.flightCarrierCode}
										{segment.flightNumber}
									</div>
									{index !== destinationAirport.flightSegmentList.length - 1 && (
										<span className='flight-list-item-mobile'>&nbsp;|&nbsp;</span>

									)}
								</React.Fragment>
							))
						) : (
							<></>
						)}
					</div>
				</div>
				<div className='flight-deatils-mobile'>
					<div className='top-block-mobile'>
						<div className='top-block-badges-mobile'>
							{destinationAirport.allotmentAvailable && (
								<div className='allotment-badges'>{t("DASHBOARD.ALLMNT")}</div>
							)}

							{(destinationAirport.overBookingAllowed ||
								destinationAirport.overHangShipment ||
								destinationAirport.bigShipment ||
								destinationAirport.isForceQueued) && (


									<div className='no-confirm-badge'>{t('CHOOSE_FLT.NO_INS_CONFIR')}</div>


								)}
						</div>
						{!toBeProcessedData && <button className='see-details-linkbutton' onClick={handleSeeDetailsButtonClick}>{t('COMMON.SEE_DETAILS')}</button>}
					</div>
					<div className='bottom-block'>
						<div className='flight-deatils-left-block'>
							<div className='flight-deatils-time'>{departureTime.format("HH:mm")}</div>
							<div className='flight-deatils-airport' >{origin}</div>
							<div className='flight-deatils-day'>{departureDate.format("ddd DD MMM")}</div>
						</div>
						<div className='flight-deatils-middle-block'>
							<div className='plane-path'>
								<div className='origin-destination-icon dark'></div>
								<div className='transit-line'></div>
								{/* <img src={leftLineShort} alt='leftLine' className='left-line-short' /> */}

								{destinationAirport.flightSegmentList[0].flightType !=
									'T' ? (
									<img src={flightIcon} alt='Flight' title='Flight' className='plane-path-flight-icon' />
								) : (
									<img src={truckIcon} alt='Flight' title='Flight' className='plane-path-flight-icon' />
								)}




								<div className='transit-line'></div>
								<div className='origin-destination-icon dark'></div>

								{/* <img src={rightLineShort} alt='rightLine' className='left-line-short' /> */}
							</div>
							{routes ? (
								<div className='duration'>
									<div className='duration-stop'>{routes} {t("COMMON.STOP")}</div>
									<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
								</div>

							) : (
								<div className='duration'>
									<div className='duration-stop'>Direct</div>
									<div className='duration-flying-hours'>{getFormatedTime(destinationAirport.cumulativeJourneyTime)}</div>
								</div>
							)}
						</div>
						<div className='flight-deatils-right-block'>
							<div className='flight-deatils-time'>{arrivalTime.format("HH:mm")}</div>
							<div className='flight-deatils-airport' >{destination}</div>
							<div className='flight-deatils-day'>{arrivalDate.format("ddd DD MMM")}</div>
						</div>
					</div>

				</div>
				{showRightSection && (!isInterlineAgent || showChooseButton) && (
					<div className='vertical-divider-line'></div>
				)}
				{/* {showRightSection && (<div className='vertical-divider-line'></div>)} */}
				{/* <div className='vertical-divider-line'></div> */}
				{showRightSection && (
					<div className='pricing'>
						{destinationAirport.service &&
							destinationAirport.service === SERVICES.FAST_TRACK && (
								<img src={fastTrack} alt="fastTrack" title="fastTrack" className='flight-card-fasttrack' />
							)}

						{/* {!isHideRate ? ( */}
						{isInterlineAgent ? (

							<div className='pricing-details-content-mobile' />
						) : destinationAirport.ratingDetails &&
							destinationAirport.ratingDetails.length > 0 &&
							destinationAirport.ratingDetails[0].totalRate &&
							destinationAirport.ratingDetails[0].totalRate !== 0 &&
							!isHideRate ? (
							<div className='pricing-details-content-mobile'>
								<div className='rating-info'>
									{getRatingDetailsToDisplay()}
								</div>
								<div className='currency-info'>
									{getAmountDetailsToDisplay(true)}
								</div>

								{/* {destinationAirport.priceClass ? (
										<div className="rate-type-info">

											{t(RATE_TYPES[destinationAirport.priceClass])}

										</div>
									) : (
										<></>
									)} */}
							</div>
						) : (
							<div className='no-rates'>{t("COMMON.NO_RATES")}</div>
						)}



						{showChooseButton && (
							<button
								type='button'
								className='primary-button  w-100'
								onClick={() => handleFlightSelect(destinationAirport)}

							>
								{t('COMMON.BOOK')}
							</button>
						)}

					</div>
				)}

				{isFlightDetailsPopupOpen && (
					<FlightDetailsPopup
						destinationAirport={destinationAirport}
						searchFormData={searchFormData}
						onClose={handleSeeDetailsButtonClick}
						showDropoffPickup={showDropoffPickup}
						showFooter={showFooter}
					/>
				)}
			</div>



		</>
	)
}

export default FlightDetails
